import './styles.scss';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { useChargebacks } from '../../../../store/chargebacks';
import DialogExportTransactions from './dialog';
import l from '../../../../lang';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file-download.svg';
import { segmentTransactionsDownloadReport } from '../../../../utils/analytics';

const ExportTransactions = () => {
  const { showExportChargebacks } = useChargebacks();
  return (
    <>
      <DialogExportTransactions />
      <div className="export_chargebacks__top_button">
        <ButtonCustom
          text={<span className="export_chargebacks__top_button__text">{l('exportTransactions.title')}</span>}
          onClick={() => {
            segmentTransactionsDownloadReport();
            showExportChargebacks(true);
          }}
          variant="outlined"
          startIcon={<DownloadIcon className="export_chargebacks__top_button__icon" />}
          fullWidth
        />
      </div>
    </>
  );
};

export default ExportTransactions;
